import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getProjectAddonsRequest } from "Api/organizations/projects/getProjectAddons.request";

import type { ProjectAddons } from "Api/organizations/projects/getProjectAddons.request";

export const getProjectAddons = createAsyncThunk<
  ProjectAddons,
  {
    organizationId: string;
    subscriptionId: string;
  }
>(
  "app/organization/get_project_addons",
  async ({ organizationId, subscriptionId }, { rejectWithValue }) => {
    try {
      const addons = await getProjectAddonsRequest({
        organizationId,
        subscriptionId
      });
      return addons;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type ProjectAddonsState = {
  data: Record<string, ProjectAddons>;
  error?: unknown;
  loadingAddons: boolean;
};

const initialState: ProjectAddonsState = {
  data: {},
  loadingAddons: false
};

const projectAddonsReducer = createSlice({
  name: "app/organization/project/addons",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getProjectAddons.pending, state => {
        state.loadingAddons = true;
        delete state.error;
      })
      .addCase(getProjectAddons.fulfilled, (state, { meta, payload }) => {
        const { subscriptionId } = meta.arg;

        state.data[subscriptionId] = payload;
        state.loadingAddons = false;
      })
      .addCase(getProjectAddons.rejected, (state, { payload }) => {
        state.loadingAddons = false;
        state.error = payload;
      });
  }
});

export default projectAddonsReducer.reducer;
